import React from "react";

function PrivacyPolicy() {
  return (
    <div style={{maxWidth:"900px", margin:"auto", padding:"40px", fontFamily:"Arial"}}>

      <h1>Civilink Privacy Policy</h1>
      <p><strong>Last Updated:</strong> March 2026</p>

      <p>
        This Privacy Policy explains how Civilink Private Limited ("Civilink",
        "we", "our", "us") collects, uses, stores, and protects your information
        when you use the Civilink platform including our website and mobile
        applications.
      </p>

      <h2>1. Platform Overview</h2>
      <p>
        Civilink is a technology platform connecting Engineers, Architects,
        Construction Workers, Vendors, and Property Buyers and Sellers.
        Civilink operates as a technology intermediary and facilitator under
        Indian IT laws.
      </p>

      <h2>2. Information We Collect</h2>

      <h3>Personal Information</h3>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Location</li>
        <li>Profile photos</li>
      </ul>

      <h3>Professional Information</h3>
      <ul>
        <li>Educational certificates</li>
        <li>Professional licenses</li>
        <li>Verification documents</li>
      </ul>

      <h3>Property & Listing Information</h3>
      <ul>
        <li>Property details</li>
        <li>Land information</li>
        <li>Images and descriptions</li>
      </ul>

      <h3>Technical Data</h3>
      <ul>
        <li>Device information</li>
        <li>IP address</li>
        <li>Browser type</li>
      </ul>

      <h2>3. How We Use Information</h2>
      <p>
        Civilink uses collected data to provide platform services, enable
        communication between users, maintain security, improve features,
        and comply with legal requirements.
      </p>

      <h2>4. Data Security</h2>
      <p>
        Civilink uses secure servers, encrypted connections (HTTPS), and
        restricted administrative access to protect user information.
      </p>

      <h2>5. Third Party Services</h2>
      <p>
        Civilink may share limited data with trusted service providers such
        as cloud hosting services, SMS OTP providers, and payment gateways.
      </p>

      <h2>6. User Responsibilities</h2>
      <p>
        Users are responsible for verifying property ownership, professional
        credentials, and transaction details before engaging with other users.
      </p>

      <h2>7. Children’s Privacy</h2>
      <p>
        Civilink services are intended for individuals aged 18 years and above.
      </p>

      <h2>8. User Rights</h2>
      <p>
        Users may access, update, or delete their account information by
        contacting Civilink support.
      </p>

      <h2>9. Changes to Privacy Policy</h2>
      <p>
        Civilink may update this policy periodically. Continued use of the
        platform indicates acceptance of updated policies.
      </p>

      <h2>10. Contact</h2>
      <p>
        Civilink Private Limited<br/>
        Tamil Nadu, India<br/>
        Email: civilink.official@gmail.com
      </p>

    </div>
  );
}

export default PrivacyPolicy;